module.exports = __webpack_public_path__ + "img/company-icon-primary.dfec7687.svg";